<script setup lang="ts">
import { computed, watch } from 'vue'
import { useTranslate } from '@tolgee/vue'

import { useCloudinary } from '@/composables/cloudinary'

interface Props {
  defaultImage?: string
  disabled?: boolean
}

interface Events {
  (e: 'upload', value: string): void
}

const props = defineProps<Props>()
const emit = defineEmits<Events>()

const { openUploadModal, imageUrl } = useCloudinary()
const { t } = useTranslate('local')

const image = computed(() => imageUrl.value || props.defaultImage)

watch(imageUrl, () => {
  emit('upload', imageUrl.value)
})
</script>

<template>
  <div class="gs-upload">
    <div v-if="image" class="gs-upload-image">
      <img :src="image" alt="uploaded image" />
    </div>
    <GsButton @click.prevent="openUploadModal" type="tertiary" :disabled="disabled" full-width>
      {{ t('upload.button') }}
    </GsButton>
  </div>
</template>

<style lang="scss" scoped>
.gs-upload-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  margin: 0 auto 16px auto;

  img {
    border-radius: 50%;
    width: 150px;
    height: 150px;
    object-fit: cover;
  }
}
</style>
